import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoLocalEquipamentoEnum } from "core/features/equipamento/typings";

const { Option } = Select;

export interface SelectTipoLocalEquipamentoProps<T = any>
  extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
}

function SelectTipoLocalEquipamento({
  value,
  isInvalid,
  onChange,
  ...rest
}: SelectTipoLocalEquipamentoProps) {
  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder="Selecione o local "
        style={{ width: "100%" }}
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        <Option value={TipoLocalEquipamentoEnum.AreaComum} key="a">
          Área Comum
        </Option>
        <Option value={TipoLocalEquipamentoEnum.Outros} key="o">
          Outros
        </Option>
      </SelectBaseAntd>
    </>
  );
}

export default SelectTipoLocalEquipamento;
